// @flow
import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import './assets/stylesheets/layout.scss';
import './assets/stylesheets/commons.scss';
import envConfig from './configs/envConfig';

import getStore from './main/store';
import App from './main/app';

import { enableSentry, history } from './services/helpers';

const store = getStore(true); // isClientSide = true

// // flow-disable-next-line
// something.flow(doesnt.like).for.instance()

// registering service worker
// Check for browser support of service worker

// const registerServiceWorker = () => {
//   if ("serviceWorker" in navigator) {
//     // eslint-disable-next-line compat/compat
//     navigator.serviceWorker
//       .register("sw.js")
//       .then(registration => {
//         // eslint-disable-next-line no-console
//         console.log(
//           "Registration successful ** , scope is:",
//           registration.scope
//         );
//       })
//       .catch(err => {
//         // eslint-disable-next-line no-console
//         console.log("Service worker registration failed, error:", err);
//       });
//   }
// };

// // eslint-disable-next-line no-console
// console.log(" process.env.NODE_ENV = ", process.env.NODE_ENV);

// registerServiceWorker();

// setting gtag config instance
const customDimensionsMap = {
  custom_map: {
    dimension1: 'userId',
    dimension2: 'userLocation',
    dimension3: 'userOrg'
  }
};
if (envConfig.analyticsFlag) {
  // Universal Analytics Id
  if (envConfig.analyticsId) {
    window.gtag('config', envConfig.analyticsId, customDimensionsMap);
  }
  // Google Analytics 4 Id
  if (envConfig.ga4AnalyticsId) {
    window.gtag('config', envConfig.ga4AnalyticsId, customDimensionsMap);
  }
}
const containerElem = document.querySelector('#app');

const wrapApp = (AppComponent, reduxStore) => (
  <Provider store={reduxStore}>
    <Router history={history}>
      <AppComponent />
    </Router>
  </Provider>
);

// enableSentry();

// flow-disable-next-line  //remove this comment later and resolve the issue :: TORESOLVE
render(wrapApp(App, store), containerElem);

// TODO: add code for hot module replacement
